import React, { Component, createRef } from "react";
import {
    Form,
    Input,
    Button,
    message,
    Upload,
    Modal
} from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import url from "@utils/url";
import { create, contractList } from "@api/signin";

const { HOST } = url;

class NormalLoginForm extends Component {
    formRef = createRef();

    state = {
        imageUrl: "",
        loading: false,
        contractShow: "none",
        contractList: [],
        currentContract: {}
    };

    componentDidMount() {
        this.getContractList();
    }

    handleSubmit = async () => {
        try {
            const values = await this.formRef.current.validateFields();
            this.handleCreate(values);
        } catch (err) {
            message.error("请完善表单内容!!!");
        }
    };

    handleCreate = async values => {
        Object.assign(values, {
            licenseUrl: values.licenseUrl.file.response.data,
            cooperatePrice: Number(values.cooperatePrice),
            reward: Number(values.reward)
        });

        const res = await create(values);

        if (res.data.meta.errCode !== 0) {
            message.error(res.data.meta.errMsg);
            return;
        }

        Modal.success({
            title: "恭喜提交成功",
            content: "敬请期待审核结果",
            onOk() {
                window.location.reload();
            },
        });
    };

    checkPhone = (rule, value) => {
        const tempValue = value || '';

        if (!/^[1][0-9]{10}$/.test(tempValue) && tempValue.length > 0) {
            return Promise.reject("请填入正确的手机号");
        }

        return Promise.resolve();
    };

    checkIsInt = (rule, value) => {
        const v = value || '';
        const tempVal = v.toString();

        if (tempVal.indexOf('.') !== -1) {
            return Promise.reject("合作价格必须为整数");
        }

        return Promise.resolve();
    };

    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener("load", () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    handleChange = info => {
        if (info.file.status === "uploading") {
            this.setState({ loading: true });
            return;
        }
        if (info.file.status === "done") {
            this.getBase64(info.file.originFileObj, imageUrl =>
                this.setState({
                    imageUrl,
                    loading: false
                })
            );
        }
    };

    getUploadUrl = () => {
        return `${HOST}/cps-gateway/api/v1/partner/img/upload`;
    };

    handleCooperateTypeChange = val => {
        const temp = this.state.contractList.find(
            item => item.contractType === val
        );

        this.setState({
            currentContract: temp,
            contractShow: "inline"
        });
    };

    getContractList = async () => {
        const res = await contractList();

        if (res.data.meta.errCode !== 0) {
            message.error(res.data.meta.errMsg);
            return;
        }

        this.setState({ contractList: res.data.data.list || [] });
    };

    handleAfterClose = () => {
        console.log("close");
    };

    handleCancel = () => {
        this.setState({ visible: false });
    };

    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 17, offset: 1 }
            }
        };

        const uploadButton = (
            <div>
                {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
                <div className="ant-upload-text">Upload</div>
            </div>
        );
        const { currentContract, imageUrl } = this.state

        return (
            <div className="signin">
                <div className="signin_title">创建新合作方</div>
                <div className="signin_box">
                    <Form ref={this.formRef} className="login-form" onFinish={this.handleSubmit}>
                        <Form.Item 
                            {...formItemLayout} 
                            label="合作方名称"
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: "请填写合作方名称"
                                }
                            ]}
                        >
                            <Input placeholder="请填写合作方名称" />
                        </Form.Item>
                        <Form.Item 
                            {...formItemLayout} 
                            label="联系人名称"
                            name="contact"
                            rules={[
                                {
                                    required: true,
                                    message: "请填写合作方名称"
                                }
                            ]}
                        >
                            <Input placeholder="请填写合作方名称" />
                        </Form.Item>
                        <Form.Item 
                            {...formItemLayout} 
                            label="手机号"
                            name="mobile"
                            rules={[
                                {
                                    required: true,
                                    message: "请填写手机号"
                                },
                                {
                                    validator: this.checkPhone
                                }
                            ]}
                        >
                            <Input placeholder="请填写手机号" />
                        </Form.Item>
                        <Form.Item 
                            {...formItemLayout} 
                            label="通讯地址"
                            name="address"
                            rules={[
                                {
                                    required: true,
                                    message: "请填写通讯地址"
                                }
                            ]}
                        >
                            <Input placeholder="请填写通讯地址" />
                        </Form.Item>
                        <Form.Item 
                            {...formItemLayout} 
                            label="营业执照图片"
                            name="licenseUrl"
                            rules={[
                                {
                                    required: true,
                                    message: "请上传营业执照图片"
                                }
                            ]}
                        >
                            <Upload
                                name="filecontent"
                                listType="picture-card"
                                className="avatar-uploader"
                                showUploadList={false}
                                action={this.getUploadUrl}
                                onChange={this.handleChange}
                            >
                                {imageUrl ? (
                                    <img
                                        src={imageUrl}
                                        alt="avatar"
                                        style={{ width: 126, height: 126 }}
                                    />
                                ) : (
                                    uploadButton
                                )}
                            </Upload>
                        </Form.Item>
                        <Form.Item 
                            {...formItemLayout} 
                            label="开户行"
                            name="bankName"
                            rules={[
                                {
                                    required: true,
                                    message: "请填写开户行"
                                }
                            ]}
                        >
                            <Input placeholder="请填写开户行" />
                        </Form.Item>
                        <Form.Item 
                            {...formItemLayout} 
                            label="开户名"
                            name="bankAccountName"
                            rules={[
                                {
                                    required: true,
                                    message: "请填写开户名"
                                }
                            ]}
                        >
                            <Input placeholder="请填写开户行" />
                        </Form.Item>
                        <Form.Item 
                            {...formItemLayout} 
                            label="银行账户"
                            name="bankAccount"
                            rules={[
                                {
                                    required: true,
                                    message: "请填写银行账户"
                                }
                            ]}
                        >
                            <Input placeholder="请填写银行账户" />
                        </Form.Item>
                        <Form.Item 
                            {...formItemLayout} 
                            label="税号"
                            name="taxNumber"
                            rules={[
                                {
                                    required: true,
                                    message: "请填写税号"
                                }
                            ]}
                        >
                            <Input placeholder="请填写税号" />
                        </Form.Item>
                        <Form.Item 
                            {...formItemLayout} 
                            label="合作价格(单位: 分)" 
                            name="cooperatePrice"
                            style={{display: currentContract.contractType === 'cpa' || currentContract.contractType === 'cpcc' ? 'block' : 'none'}}
                            rules={[
                                {
                                    required: currentContract.contractType === 'cpa' || currentContract.contractType === 'cpcc' ? true : false,
                                    message: "请填写合作价格"
                                },
                                {
                                    validator: this.checkIsInt
                                }
                            ]}
                        >
                            <Input
                                type="number"
                                placeholder="请填写合作价格, 注意单位为分, 例如: 20分, 输入 20 即可"
                            />
                        </Form.Item>
                        <Form.Item style={{ textAlign: "center" }}>
                            <Button type="primary" htmlType="submit">
                                创建
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        );
    }
}

export default NormalLoginForm;
